<template>
  <div class="app-calendar overflow-hidden border">
    <div class="row no-gutters">
      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0 card-scroll">
            <b-overlay
              variant="gray"
              :show="displayOverlay"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
              <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar full"

              />
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
// Full Calendar Plugins
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { BOverlay } from "bootstrap-vue";

export default {
  components: {
    FullCalendar,
    BOverlay,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: "dayGridMonth",
      },
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>